<template>
	<div grey-back full-height>

		<v-toolbar dark flat fixed nopadding>
      		<v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>
      		<v-toolbar-title>Client Businesses</v-toolbar-title>
      		<!-- <v-spacer></v-spacer>
      		<v-btn icon @click="fn_newBusiness"><v-icon>add</v-icon></v-btn> -->
            <!-- <v-btn color="success" @click="fn_removeDatabase($root.CurrentBusiness.BusinessID)">text</v-btn> -->
            <!-- <v-btn color="success" @click="fn_getActiveBusinessListFromServer">text</v-btn> -->
    	</v-toolbar>

	    <div class="hasToolbar">
            <v-alert type="info" :value="true">Select business to continue</v-alert>
	    	
	    	<!-- <v-list grey-back two-line nopadding v-if="!$root.CurrentBusiness.IsAccountantOnly"> -->
            <!-- <v-list grey-back two-line nopadding v-if="items && items.length">
	    		
	    		<div v-for="(item, index) in items" :key="index">
	    			<v-list-tile class="ma-3 white-background" style="border-radius: 8px;" @click="fn_checkBusinessType(item)">

	                    <v-list-tile-content>
	                        <v-list-tile-title>{{item.BusinessName}}</v-list-tile-title>
	                        <v-list-tile-sub-title greencolor v-if="item.isActive">Currently Logged-in</v-list-tile-sub-title>
	                    </v-list-tile-content>

	                    <v-list-tile-action v-if="!item.isActive">
                            <v-btn color="primary" outline small capitalize v-if="item.DataRestore == 0 && item.DataDrive">Restore</v-btn>
                            <v-icon color="primary" v-else>keyboard_arrow_right</v-icon>
			            </v-list-tile-action>

                        <v-list-tile-action v-else>
                            <v-icon color="success">done</v-icon>
                        </v-list-tile-action>

	                </v-list-tile>

	    		</div>

	    	</v-list> -->

            <v-list grey-back two-line nopadding v-if="clientbusinesses.length">
                <!-- <v-subheader>Client Businesses</v-subheader> -->
	    		<div v-for="(item, index) in clientbusinesses" :key="index">
	    			<!-- <v-list-tile class="ma-3 white-background" style="border-radius: 8px;" @click="$root.fn_connectWithClientBusiness(item)"> -->
                    <v-list-tile class="ma-3 white-background" style="border-radius: 8px;" @click="fn_checkBusinessType(item)">

                        <v-list-tile-action @click="fn_viewMore($event, item)">
                            <!-- <v-icon>expand_more</v-icon> -->
                            <v-menu v-model="item.moreOptions" :min-width="148">
                                <v-btn slot="activator" icon>
                                    <v-icon>expand_more</v-icon>
                                </v-btn>

                                <v-list nopadding style="border-radius: 5px;">
                                    <v-list-tile @click="fn_checkBusinessType(item)">
                                        <v-list-tile-action style="min-width: 36px;"><v-icon font20 >link</v-icon></v-list-tile-action>
                                        <v-list-tile-title>Connect</v-list-tile-title>
                                    </v-list-tile>

                                    <!-- <v-divider></v-divider>

                                    <v-list-tile @click="fn_scanQRCode(item.BusinessID)">
                                        <v-list-tile-action style="min-width: 36px;"><v-icon font20 >computer</v-icon></v-list-tile-action>
                                        <v-list-tile-title>Connect Via Desktop</v-list-tile-title>
                                    </v-list-tile> -->

                                    <v-divider></v-divider>

                                    <v-list-tile color="red" @click="fn_openDialogAction(item.BusinessID, item.BusinessName, index)">
                                        <v-list-tile-action style="min-width: 36px;"><v-icon style="color: red !important;" font20>remove_circle_outline</v-icon></v-list-tile-action>
                                        <v-list-tile-title >Remove</v-list-tile-title>
                                    </v-list-tile>
                                </v-list>

                            </v-menu>
			            </v-list-tile-action>

	                    <v-list-tile-content>
	                        <v-list-tile-title>{{item.BusinessName}}</v-list-tile-title>
                            <v-list-tile-sub-title v-if="item.lastLogin">Last Logged-in</v-list-tile-sub-title>
	                    </v-list-tile-content>

	                    <v-list-tile-action>
                            <v-icon color="primary">keyboard_arrow_right</v-icon>
			            </v-list-tile-action>

	                </v-list-tile>
	    		</div>

	    	</v-list>

            <!-- <v-card noshadow class="create-placeholder-card" v-if="!clientbusinesses.length && !items.length">
                <v-card-text @click="fn_newBusiness">

                    <div center-align>
                        <div v-ripple class="placeholder-icon">
                            <i aria-hidden="true" class="v-icon material-icons add-icon">add</i>
                            <img src="../../../assets/icon_wallet.svg" alt="">
                        </div><br>

                        <p class="title light-opacity-color">Add New Business</p>
                    </div>
                </v-card-text>
            </v-card> -->

	    </div>

		<v-dialog v-model="restoreDialog" no-click-animation persistent max-width="290">
            <v-card>
                <v-card-text display-block>
                    <div class="pt-1 pb-2">Restoring Data <span v-if="selectedBusinessItem && selectedBusinessItem.BusinessName">for <strong>{{ selectedBusinessItem.BusinessName }}</strong></span></div>
                    <div>{{restoreStatus ? restoreStatus + '%' : ''}}</div>
                    <v-progress-linear indeterminate v-if="!restoreStatus || restoreStatus >= 100"></v-progress-linear>
                    <v-progress-linear v-model="restoreStatus" :buffer-value="100" buffer v-else></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>

		<v-snackbar :timeout="0" v-model="msgAlert">Something went wrong!
            <v-btn flat color="primary" @click.native="fn_getActiveBusinessListFromServer">Retry</v-btn>
        </v-snackbar>

	    <dialog-confirmation ref="ref_dialogConfirmation" :header="confirmationHeader" :confirmationMessage="confirmationMessage" :actionMethod="actionMethod" :hideClose="hideClose" :okBtnText="okBtnText" :cancelBtnText="cancelBtnText"></dialog-confirmation>

	</div>
</template>

<script>

import dialogConfirmation from '../../dialogs/dialog_confirmation'
// import {restoreMixin} from './restore_mixin'
let isCalled = false;
	export default{
		// mixins:[restoreMixin],
		data(){
			return{
				items:[],
                clientbusinesses:[],
				seletedItem:null,
				restoreStatusObj:null,
				restoreStatus:null,
                // bufferSize:100,
				restoreDialog:false,
				// selectedBusinessName:null,
				msgAlert:false,
				confirmationMessage:null,
                confirmationHeader:null,
                actionMethod:null,
				selectedBusinessItem:null,
                hideClose:false,
                okBtnText:null,
                cancelBtnText:null,
                businessRestoreType:null
			}
		},
		components:{
			'dialog-confirmation': dialogConfirmation
		},
		methods:{

            fn_viewMore: function(event, item){
                event.stopPropagation();
                item.moreOptions = true;
            },

            fn_openDialogAction: function(businessId, businessName, index){
                // event.stopPropagation();
                let self = this;
                function removebusiness(){
                    self.fn_closeDialog();
                    self.fn_removeClientBusiness(businessId, index);
                }

                this.confirmationHeader = "Remove Client Business";
                this.confirmationMessage = "<strong>" + businessName + "</strong> will be removed from client business list.";
                this.okBtnText = "Remove";
                this.cancelBtnText = "Cancel";
                this.actionMethod = removebusiness;
                this.hideClose = false;
                this.fn_openDialogConfirmation();
            },

            fn_removeClientBusiness: function(businessId, index){
                if(!navigator.onLine){
                    this.showToast('Internet not available');
                    return;
                }

                this.msgAlert = false;
                this.showLoading('Please wait...');
                this.$root.fn_getAuthToken(token=>{
                    if(token=='error'){
                        this.hideLoading();
                    }
                    else{
                        let self = this;
                        let filterObject = {token:token, isLoggedIn:true, businessId:businessId};
                        this.getServerData('RemoveClientBusiness', filterObject, 
                            {
                                onSuccess: function(response){
                                    console.log(response);
                                    self.clientbusinesses.splice(index, 1);
                                    self.hideLoading();
                                    self.showToast('Client business removed');
                                }, 
                                onError: function(error){
                                    console.log(error);
                                    self.showToast('Something went wrong. Try again.');
                                    self.hideLoading();
                                }, 
                            }
                        );
                    }
                })
            },

			fn_checkGoogleAccountSelection: function(business){
                // this.restoreStatus = null;
                // this.restoreStatusObj = null;
				let self = this;
				// this.selectedBusinessName = business.BusinessName;
                this.getData('CheckGoogleAccount', null, 
				{
					onSuccess: function(response){
						console.log(response);
						let isSelected = JSON.parse(response);
						isSelected ? self.fn_checkRestoreSize(business) : self.fn_showGoogleAccounts(business);
					}, 
					onError: function(error){
						console.log(error);
					}
				});
            },

            fn_showGoogleAccounts: function(business){
                let self = this;
               	this.getData('ShowGoogleAccounts', null, 
                    {
                        onSuccess: function(response){
                            console.log(response);
                            self.fn_checkDataDrive(response, business);
                        }, 
                        onError: function(error){
                            console.log(error);
                            if(error=="Request Cancel"){
                                console.log(error);
                            }
                            else if(!navigator.onLine){
                                self.showToast('Internet not available');
                            }
                            else{
                                self.showToast("Something went wrong. Try again");
                            }
                            
                        }
                    }
                );
            },

            fn_checkDataDrive: function(dataDrive, business){
                if(business.DataDrive && dataDrive != business.DataDrive){
					/*global AndroidRoutingTest*/
					AndroidRoutingTest.revokeAccount();
                    this.confirmationMessage = 'Kindly choose or configure <strong>' +business.DataDrive+ '</strong> to restore <strong>' +business.BusinessName+ '</strong> data.'
                    this.actionMethod = this.fn_confirmAction;
                    this.hideClose = true;
                    this.okBtnText = null;
                    this.cancelBtnText = null;
					this.selectedBusinessItem = business;
                    this.fn_openDialogConfirmation();
                }
                else{
                    this.fn_updateDataDrive(dataDrive, business);
                }
            },

			fn_confirmAction: function(){
                AndroidRoutingTest.revokeAccount();
                this.fn_closeDialog();
                setTimeout(() => {
					this.fn_showGoogleAccounts(this.selectedBusinessItem);
				}, 300);
            },

			fn_closeDialog: function () {
                // AndroidRoutingTest.revokeAccount();
                this.$refs['ref_dialogConfirmation'].closeDialogWeb();
            },

            // dataDrive == selected/configured email id
            fn_updateDataDrive: function(dataDrive, business){
                let self = this;
                let postObj = {"dataDrive":dataDrive};
                this.postData('UpdateDataDrive', postObj, 
                    {
                        onSuccess: function(response){
                            console.log(response);
                            //Checking restore size to restore data files
                            // self.fn_checkRestoreSize(business);
                            if(self.businessRestoreType == 'firebase'){
                                self.hideLoading();
                                business.DataDrive = dataDrive;
                                // self.fn_startFirebaseRestore(business);
                            }
                            else{
                                //Checking restore size to restore data files
                                self.fn_checkRestoreSize(business);
                            }
                        }, 
                        onError: function(error){
                            console.log(error);
                            self.hideLoading();
                            self.showToast("Something went wrong. Try again");
                        }, 
                    }
                );
            },
			
			fn_goBack: function(type){
                if(type != 'login' && this.$route.query.exitapp){
                    this.exitApp();
                }
                else{
                    if(this.$route.query.gotosettings || this.$root.CurrentBusiness.IsAccountantOnly){
                        this.$router.replace('/settings');
                    }
                    else{
                        if(this.$route.query.exitapp){
                            this.$router.replace('/actions');
                        }
                        else{
                            this.$router.go(-1);
                        }
                    }
                }
			},

            fn_newBusiness: function(){
                this.$router.push({path:"/registration/business/usertype"});
            },

			fn_openDialogConfirmation: function(){
				this.$refs['ref_dialogConfirmation'].openDialogWeb();
			},

			fn_getActiveBusinessListFromServer: function(){
                if(!navigator.onLine){
                    this.msgAlert = true;
                    this.showToast('Internet not available');
                    this.hideLoading();
                    return;
                }

                this.msgAlert = false;
                this.showLoading('Getting Details...');
                this.$root.fn_getAuthToken(token=>{
                    if(token=='error'){
                        this.msgAlert = true;
                        this.hideLoading();
                    }
                    else{
                        let self = this;
                        let filterObject = {token:token};
                        this.getServerData('GetAllActiveBusiness', filterObject, 
                            {
                                onSuccess: function(response){
                                    console.log(response);
                                    // self.businessList = JSON.parse(response);
                                    let serverItems = JSON.parse(response);
                                    self.fn_businessListFromLocal(serverItems);
                                }, 
                                onError: function(error){
                                    console.log(error);
                                    self.msgAlert = true;
                                    self.hideLoading();
                                }, 
                            }
                        );
                    }
                })
            },

			fn_businessListFromLocal: function(serverItems){
	            
	            let self = this;
	            this.getData('AllActivePassiveBusinesses', null, 
	                {
	                    onSuccess: function(response){
	                    	console.log(response);
	                    	// self.items = JSON.parse(response);
							let localItems = JSON.parse(response);
                            let businessToPost = [];
                            for(let i=0; i<serverItems.mybusinesses.length; i++){
                                for(let j=0; j<localItems.length; j++){
                                    if(serverItems.mybusinesses[i].BusinessID == localItems[j].BusinessID){
                                        serverItems.mybusinesses[i].DataRestore = localItems[j].DataRestore;
										serverItems.mybusinesses[i].isActive = localItems[j].isActive;
                                        serverItems.mybusinesses[i].alreadyInBusinessList = true;
                                    }
                                }

                                if(!serverItems.mybusinesses[i].alreadyInBusinessList){
                                    serverItems.mybusinesses[i].DataRestore = -1;
                                    businessToPost.push(serverItems.mybusinesses[i]);
                                }
                            }

                            self.items = serverItems.mybusinesses;

                            self.clientbusinesses = serverItems.clientbusinesses;

                            // shifting last login client business to top
                            if(self.clientbusinesses && self.clientbusinesses.length && localStorage.getItem('recentBusinessObj')){
                                let lastLoginBusiness = JSON.parse(localStorage.getItem('recentBusinessObj'));
                                let itemIndex = self.clientbusinesses.findIndex(item=>item.BusinessID == lastLoginBusiness.clientBusinessId);
                                if(itemIndex != -1){
                                    let tempBusinessToUnshift = self.clientbusinesses[itemIndex];
                                    self.clientbusinesses.splice(itemIndex, 1);
                                    tempBusinessToUnshift.lastLogin = true;
                                    self.clientbusinesses.unshift(tempBusinessToUnshift);
                                }
                            }

                            for(let j=0; j<self.clientbusinesses.length; j++){
                                self.clientbusinesses[j]["moreOptions"] = false;
                            }

                            // if(localStorage.getItem('recentBusinessObj')){
                            //     localStorage.removeItem('recentBusinessObj');
                            // }

                            self.hideLoading();

                            console.log(JSON.stringify(self.items));

                            if(businessToPost.length){
                                self.fn_postBusinessList(businessToPost);
                            }
	                    }, 
	                    onError: function(error){
	                        console.log(error);
	                    }, 
	                }
	            );
			},

            fn_postBusinessList: function(businesList){
                if(!this.$root.Businesses.BusinessList){
                    this.$root.Businesses.BusinessList = [];
                }
                
                for(let i=0; i<businesList.length; i++){
                    this.$root.Businesses.BusinessList.push(businesList[i]);
                    if(!businesList[i].DataDrive || businesList[i].IsRemote){
                        businesList[i].DataRestore = -1;
                    }
                    else{
                        businesList[i].DataRestore = 0;
                    }
                    // businesList[i].DataRestore = !businesList[i].DataDrive ? -1 : 0;
                }
                let postObj = {};
                postObj.masterDataJson = {};
                postObj.masterDataJson.businessList = businesList;
                this.postData('PostAllMasterBusiness', postObj,
                    {
                        onSuccess: function(response){
                            console.log(response);
                        }, 
                        onError: function(error){
                            console.log(error);
                        }
                    }
                );
            },

            fn_businessConfirmation: function(business){

                if(this.$root.CurrentBusiness && this.$root.CurrentBusiness.BusinessID == business.BusinessID){
                    this.showToast("Already logged in");
                    return;
                }

                this.restoreStatus = null;
                this.restoreStatusObj = null;
                this.selectedBusinessItem = business;

                if(business.DataRestore == null){
                    // in case of DataRestore == null
					this.fn_switchBusiness(business);
                }
                else if(business.DataRestore == 0 && business.DataDrive){
                    this.fn_checkGoogleAccountSelection(business);
                }
                else{
                    this.confirmationMessage = "Login to continue with <strong>" + this.selectedBusinessItem.BusinessName+"</strong>";
                    this.confirmationHeader = 'Login';
                    this.actionMethod = this.fn_loginBusiness;
                    this.hideClose = false;
                    this.okBtnText = "Continue";
                    this.cancelBtnText = "Cancel";
                    this.fn_openDialogConfirmation();
                }
            },

			fn_loginBusiness: function(businessItem){
                this.fn_closeDialog();
                let business = businessItem ? businessItem : this.selectedBusinessItem;
                // if(business.DataRestore == -1 && !business.IsRemote && business.DataDrive){
                //     this.fn_getBusinessDetailsFromMainDB(business);
                // }
                // else{
                if(!business.DataDrive && business.DataRestore == -1){
                // confirm login and saving business to local db
                    this.showLoading('Please wait...');
                    this.fn_confirmBusinessLogin(business, ()=>{

                        if(!business.IsAccountantOnly){
                            this.$root.CurrentBusiness = business;
                            this.$root.fn_pushDefaultJson(business.BusinessID, business.GSTRegistrationStatus, ()=>{
                                // this.hideLoading();
                                // this.fn_switchBusiness(business);
                                this.fn_updateRestoreStatus(business);
                            }); 
                        }
                        else{
                            // this.hideLoading();
                            // this.fn_switchBusiness(business);
                            this.fn_updateRestoreStatus(business);
                        }

                    })
                }
                // }
				
				else if(business.DataRestore == -1){
					// this.fn_reopenDatabase(business, -1);
                    this.fn_getBusinessDetailsFromMainDB(business);
				}
				// else{
				// 	// in case of DataRestore == null
				// 	this.fn_switchBusiness(business);
				// }
			},

			fn_switchBusiness: function(business){
				let self = this;
	            this.getData('SwitchLocalBusiness', business.BusinessID, 
	                {
	                    onSuccess: function(response){
	                    	console.log(response);
							self.fn_reopenDatabase(business);
	                    }, 
	                    onError: function(error){
	                        console.log(error);
							self.showToast("Something went wrong. Try again");
	                    }, 
	                }
	            );
			},

			fn_reopenDatabase: function(business, dataRestore){
                let self = this;
                this.getData('ReopenDataBase', business.BusinessID, 
                    {
                        onSuccess: function(response){
                            console.log(response);
							if(dataRestore == -1){
								self.fn_getBusinessDetailsFromMainDB(business);
							}
							else{
								self.$root.fn_getBusiness(null, null, ()=>{
									self.hideLoading();
                                    // to start full backup when login to other business
                                    // on request of puran to manage insta sync
                                    self.fn_startInitialFullBackup(business.BusinessID);
                                    
                                    // self.showToast('Logged in with '+self.$root.CurrentBusiness.BusinessName);
									// self.fn_goBack('login');
								});
							}
                        }, 
                        onError: function(error){
                            console.log(error);
                            self.showToast("Something went wrong. Try again");
                        }
                    }
                );
            },

			fn_checkRestoreSize: function(business){

				if(!navigator.onLine){
					this.showToast('Internet not available');
					return;
				}

				let self = this;
				// !hideLoading ? this.showLoading("Please wait...") : '';
                this.showLoading("Please wait...");
				this.getData('RestoreSize', business.BusinessID, 
					{
						onSuccess: function(response){
							console.log(response);
							self.restoreStatusObj = JSON.parse(response);

							// confirm login and saving business to local db
							self.fn_confirmBusinessLogin(business, ()=>{

								if(self.restoreStatusObj && !self.restoreStatusObj.dbSize && !self.restoreStatusObj.localDbSize){
									// self.fn_reopenDatabase(business, -1);
                                    self.fn_getBusinessDetailsFromMainDB(business);
								}
								else{
									self.hideLoading();
									self.fn_restoreData(business);
								}

							})
							
						}, 
						onError: function(error){
							console.log(error);
							self.hideLoading();
							self.showToast("Something went wrong. Try again");
						}
					}
				);
			},

			fn_restoreData: function(business){

				if(!navigator.onLine){
					this.showToast('Internet not available');
					self.hideLoading();
					return;
				}

				this.restoreDialog = true;

				let self = this;
				this.getData('RestoreBusiness', business.BusinessID, 
					{
						onSuccess: function(response){
							console.log(response);
							self.restoreDialog = false;
							self.fn_updateRestoreStatus(business);
						}, 
						onError: function(error){
							console.log(error);
							self.restoreDialog = false;
							self.hideLoading();
							self.showToast("Something went wrong. Try again");
						}
					}
				);
			},

			fn_updateRestoreStatus: function(business){
                var self = this;
                let filterObject = {DataRestore:null};
                this.postFilterData('RestoreStatus', business.BusinessID, filterObject, 
                    {
                        onSuccess: function(response){
                            console.log(response);
							business.DataRestore = null;

                            // updating DataRestore into current business list
                            if(self.$root.Businesses.BusinessList && self.$root.Businesses.BusinessList.length){
                                for(let i=0; i<self.$root.Businesses.BusinessList.length; i++){
                                    if(self.$root.Businesses.BusinessList[i].BusinessID == business.BusinessID){
                                        self.$root.Businesses.BusinessList[i].DataRestore = null;
                                        break;
                                    }
                                }
                            }

                            // checking if request coming from change data drive
                            // ra = restore all business
                            if(self.$route.query.ra){
                                let restoreItemIndex = self.items.findIndex(item=>item.DataRestore == 0);
                                restoreItemIndex == -1 ? self.$router.replace({path:'/settings/backup', query:{changedrive:1}}) : self.showToast("Data restored for " + business.BusinessName);
                            }
                            // else just switching business
                            else{
                                self.fn_switchBusiness(business);
                            }
                        }, 
                        onError: function(error){
                            console.log(error);
                            self.showToast("Something went wrong. Try again");
                            self.hideLoading();
                        }
                    }
                );
            },

			fn_setRestoreStatus: function(status){
                this.restoreStatus = Math.round(status);
            },

			fn_getBusinessDetailsFromMainDB: function(business){
                let self = this;
                this.getData('BusinessDetailsFromMainDB', business.BusinessID, 
                    {
                        onSuccess: function(response){
                            console.log()
                            let data = JSON.parse(response);
                            //saving busness details in case of no data found of the business
                            if(!data){
                                // self.fn_saveBusinessDetail(business);
                                self.fn_saveBusinessToMasterViaMixin(business, true, function(){
                                    self.fn_saveBusinessDetail(business);
                                })
                            }

                            //checking if diffrence in GSTRegistrationStatus btw local and server 
                            else if(data.GSTRegistrationStatus != business.GSTRegistrationStatus){
                                self.$root.fn_updateTtf(business.GSTRegistrationStatus, function(){
                                    // self.fn_saveBusinessDetail(business);
                                    self.fn_saveBusinessToMasterViaMixin(business, true, function(){
                                        self.fn_saveBusinessDetail(business);
                                    })
                                })
                            }
                        },
                        onError: function(error){
                            console.log(error);
                            self.showToast("Something went wrong. Try again");
                            self.hideLoading();
                        }
                    }
                );
            },

			fn_saveBusinessDetail: function(business){
                let self = this;
                let postObj = JSON.parse(JSON.stringify(business));
                postObj.CreatedOn = new Date(postObj.CreatedOn);
                postObj.ModifiedOn = new Date(postObj.ModifiedOn);
                postObj.GSTRegistrationDate = postObj.GSTRegistrationDate ? new Date(postObj.GSTRegistrationDate) : null;
                postObj.OpeningDate = postObj.OpeningDate ? new Date(postObj.OpeningDate) : null;
                postObj.isActive = 1;
                this.postData('SaveBusinessDetail', postObj, 
                    {
                        onSuccess: function(response){
                            console.log(response);
                            self.$root.fn_pushDefaultJson(business.BusinessID, business.GSTRegistrationStatus, function(){
                                self.fn_resetDatabase(business);
                            });
                        }, 
                        onError: function(error){
                            console.log(error);
                            self.hideLoading();
                            self.showToast("Something went wrong. Try again");
                        }, 
                    }
                );
            },

			fn_resetDatabase: function(business){
                let self = this;
                this.getData('ResetDatabase', business.BusinessID, 
                    {
                        onSuccess: function(response){
                            console.log(response);
                            self.hideLoading();
                            if(self.restoreStatusObj && (self.restoreStatusObj.logoSize || self.restoreStatusObj.chunkSize)){
                                self.fn_restoreData(business);
                            }
                            else{
                                // updating restore status to null after pushing default data
                                self.fn_updateRestoreStatus(business);
                            }
                        }, 
                        onError: function(error){
                            console.log(error, 'error in reset database');
                            self.showToast("Something went wrong. Try again");
                            self.hideLoading();
                        }
                    }
                );
            },
			
            fn_startInitialFullBackup: function(businessId){
                let self = this;
                this.getData('StartInitialFullBackup', businessId, 
                    {
                        onSuccess: function(response){
                            console.log(response);
                            self.showToast('Logged in with '+self.$root.CurrentBusiness.BusinessName);
							self.fn_goBack('login');
                        }, 
                        onError: function(error){
                            console.log(error);
                            self.showToast("Data backup not started");
                            self.showToast('Logged in with '+self.$root.CurrentBusiness.BusinessName);
						    self.fn_goBack('login');
                        }
                    }
                );
            },

            fn_checkBusinessType: function(business){
                this.businessRestoreType = null;
                if(business.IsRemote && business.IsDataOwner){
                    // this.restoreDialog = true;
                    // this.restoreStatus = null;
                    this.businessRestoreType = 'firebase';
                    this.fn_getDataDrive(business);
                    // let firebaseRestoreObj = require('./business_restore_firebase').firebaseRestoreObj;
                    // firebaseRestoreObj.fn_downloadDbFromFirebase(this, business, response=>{
                    //     this.restoreDialog = false;
                    //     if(response=='error'){
                    //         this.restoreDialog = false;
                    //         this.fn_removeDatabase(business.BusinessID)
                    //         this.showToast("Something went wrong. Try again");
                    //     }
                    //     else{
                    //         this.$root.fn_getBusiness(null, null, ()=>{
                    //             this.showToast('Logged in with '+this.$root.CurrentBusiness.BusinessName);
                    //             this.$router.replace({path:"/actions"});
                    //         });
                    //     }
                    // });
                }
                else if(business.IsRemote && !business.IsDataOwner){
                    if(!isCalled){
                        isCalled = true;
                        this.$root.fn_connectWithClientBusiness(business);
                    }
                    setTimeout(() => {
                        isCalled = false;
                    }, 2000);
                }
                else{
                    this.fn_businessConfirmation(business)
                }
            },

            fn_getDataDrive: function(business){
				let self = this;
	            this.getData('GetDeviceDataDrive', null, 
	                {
	                    onSuccess: function(response){
	                    	console.log(response);
							// let dataDrive = null;
							if(response && response != 'null'){
								// dataDrive = response;
                                self.fn_checkDataDrive(response, business);
							}
                            else{
                                self.showToast("Setup data drive to restore");
                                // self.businessRestoreType = 'firebase';
                                self.fn_showGoogleAccounts(business);
                            }

							// if(self.$root.CurrentBusiness && self.$root.CurrentBusiness.IsDataOwner){
							// 	dataDrive = self.$root.CurrentBusiness.DataDrive ? self.$root.CurrentBusiness.DataDrive : null;
							// }
							
							// self.fn_registerBusiness(token, dataDrive);
	                    }, 
	                    onError: function(error){
	                        console.log(error);
	                    }, 
	                }
	            );
			},

            // fn_startFirebaseRestore: function(business){
            //     this.restoreDialog = true;
            //     this.restoreStatus = null;
            //     let firebaseRestoreObj = require('./business_restore_firebase').firebaseRestoreObj;
            //     firebaseRestoreObj.fn_downloadDbFromFirebase(this, business, response=>{
            //         this.restoreDialog = false;
            //         if(response=='error'){
            //             this.restoreDialog = false;
            //             this.fn_removeDatabase(business.BusinessID)
            //             this.showToast("Something went wrong. Try again");
            //         }
            //         else{
            //             this.$root.fn_getBusiness(null, null, ()=>{
            //                 this.showToast('Logged in with '+this.$root.CurrentBusiness.BusinessName);
            //                 this.$router.replace({path:"/actions"});
            //             });
            //         }
            //     });
            // },

            fn_removeDatabase: function(businessId){
                let self = this;

                let filterObject = {};
                filterObject.businessId = businessId;

                this.getFilterData('RemoveOwnerBusinessAndDatabase', null, filterObject, {
                    onSuccess: function(response){
                        console.log(response);
                        self.$root.CurrentBusiness = null;
                        self.fn_getActiveBusinessListFromServer();
                    },
                    onError: function(error){
                        console.log(error);
                        self.showToast('Something went wrong. Try again');
                    }
                });
            },

            fn_scanQRCode: function(businessId){

                // if(this.isScannerOpen){
                //     return;
                // }
                // this.isScannerOpen = true;

                // setTimeout(() => {
                //     this.isScannerOpen = false;
                // }, 1000);

                let self = this;

                this.showLoading("Please wait...");

                this.$root.fn_getAuthToken(function(token){

                    if(token == 'error'){
                        return;
                    }
                    
                    self.hideLoading();

                    let postObj = {}
                    postObj.token = token;

                    postObj.BusinessID = businessId;
                    postObj.TempBusinessID = null;

                    self.postServerData('DesktopLogin', postObj, 
                    {
                        onSuccess: function(response){
                            // self.isScannerOpen = false;
                            console.log(response);
                            self.showToast("QR code scanned successfully");
                        }, 
                        onError: function(error){
                            // self.isScannerOpen = false;
                            console.log(error);
                        }
                    }); 
                });
            },
		},
	  	mounted: function(){
			// AndroidRoutingTest.revokeAccount();
	  		window.js_globals.fn_onBackPress = this.fn_goBack;
			window.js_globals.fn_setRestoreStatus = this.fn_setRestoreStatus;
	  		// this.fn_items();
			this.fn_getActiveBusinessListFromServer();
	  	},

	  	beforeRouteLeave (to, from, next) {
			if(this.$refs['ref_dialogConfirmation'].dialog_confimation){
				this.$refs['ref_dialogConfirmation'].dialog_confimation = false;
				next(false);
			}
			else{
				next(true);	
			}
	    }
	}
</script>


// WEBPACK FOOTER //
// src/components/settings/business/business_list.vue